var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UPDATE_PERIOD } from "../options";
import { wait } from "../utils";
export class LiveTimer {
    constructor(buffer, time = 0) {
        var _a;
        this.buffer = buffer;
        /** fast forward multiplier, replay at a faster rate */
        this.ffm = 1;
        this.paused = false;
        this.ended = false;
        this.time = time || ((_a = this.buffer.current) === null || _a === void 0 ? void 0 : _a.time);
    }
    pause() {
        this.paused = true;
    }
    stop() {
        this.pause();
        this.ended = true;
    }
    resume() {
        this.paused = false;
        this.ended = false;
    }
    next() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ffm = 1;
            let msPeek = 1;
            const remaining = this.buffer.lastTime - this.time;
            if (remaining > UPDATE_PERIOD * 30) {
                // replay whole block at once and leave some for ff
                msPeek = remaining - UPDATE_PERIOD * 3;
            }
            else if (remaining > UPDATE_PERIOD) {
                // fast forward
                this.ffm = UPDATE_PERIOD / remaining;
            }
            const events = this.buffer.peek(msPeek);
            if (!events.length) {
                this.stop();
                return null;
            }
            const nextTime = events[events.length - 1].time;
            const delay = nextTime - this.time;
            yield wait(msPeek > 1 ? 0 : this.ffm * delay);
            this.time = nextTime;
            if (this.paused) {
                return null;
            }
            else {
                this.buffer.next(events.length);
                return { time: this.time, events };
            }
        });
    }
}
export class PlaybackTimer {
    constructor(buffer, time = 0) {
        var _a;
        this.buffer = buffer;
        /** used to measure event's playback duration */
        this.delayMarker = performance.now();
        this.paused = false;
        this.ended = false;
        this.time = time || ((_a = this.buffer.current) === null || _a === void 0 ? void 0 : _a.time);
    }
    nextSecond(time) {
        return time - (time % 1000) + 1000;
    }
    pause() {
        this.paused = true;
    }
    stop() {
        this.pause();
        this.ended = true;
    }
    resume() {
        this.paused = false;
        this.ended = false;
    }
    // play events at a stable rate while adjusting for their playback overhead
    next() {
        return __awaiter(this, void 0, void 0, function* () {
            const events = this.buffer.peek();
            if (!events.length) {
                this.stop();
                return null;
            }
            else if (events[0].time < this.buffer.firstPaint) {
                this.buffer.next(events.length);
                return { time: (this.time = this.buffer.firstPaint), events };
            }
            const nextTime = Math.min(this.nextSecond(this.time), events[0].time);
            const delay = nextTime - this.time - (performance.now() - this.delayMarker);
            yield wait(Math.max(0, delay));
            this.delayMarker = performance.now();
            this.time = nextTime;
            if (this.paused) {
                return null;
            }
            else if (events[0].time === nextTime) {
                this.buffer.next(events.length);
                return { time: this.time, events };
            }
            else {
                return { time: this.time, events: [] };
            }
        });
    }
}
//# sourceMappingURL=timer.js.map